// extracted by mini-css-extract-plugin
export default {"partner-card":"Partners_partner-card__e6k+l","partner-logo":"Partners_partner-logo__AyuEM","partner-title":"Partners_partner-title__DkIoA"};